
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prints",
      function () {
        return require("private-next-pages/prints.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prints"])
      });
    }
  